import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/style.css';
import AppRoutes from './routes';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { StoryProvider } from './context/StoryContext';
import { ensureFreshBuild } from './utils/ensureFreshBuild';

const hash = new URL(window.location.href).searchParams.get("hash");

if (hash) {
  localStorage.setItem("appHash", hash);
}
let appRendered = false;

const renderApp = () => {
  if (appRendered) return;
  appRendered = true;

  serviceWorkerRegistration.unregister();

  const root = ReactDOM.createRoot(document.getElementById('root'));

  root.render(
    <React.StrictMode>
      <StoryProvider>
        <AppRoutes />
      </StoryProvider>
    </React.StrictMode>
  );

  reportWebVitals();
};

const bootstrap = async () => {
  let bootstrapTimedOut = false;
  const safetyTimer = setTimeout(() => {
    bootstrapTimedOut = true;
    if (!appRendered) renderApp();
  }, 7000);

  try {
    const canContinue = await ensureFreshBuild();
    if (bootstrapTimedOut) return;
    clearTimeout(safetyTimer);
    if (!canContinue) {
      return;
    }
    renderApp();
  } catch (e) {
    clearTimeout(safetyTimer);
    if (!appRendered) renderApp();
  }
};

bootstrap();
